<template>
  <div class="page-container">
    <Hero title="What to eat" imageUrl="jordan-arnold-Ul07QK2AR-0-unsplash.jpeg" altText="Photo by Jordan Arnold on Unsplash"/>
    <section class="container">
        <section>
            <h2 class="title">The meals to choose from</h2>
            <p class="subtitle">You will be able to choose one of the following meals, that will be enjoyed during the reception for dinner.</p>
        </section>
        <div class="grid wrap">
            <div class="col col-size-6">
                <h3 class="header">Braised Boneless Short Ribs</h3>
                <p class="subtitle">Topped with caramalized onions. Served with mashed potatoes, and oven roasted vegetables.</p>
            </div>
            <div class="col col-size-6">
                <h3 class="header">Baked Stuffed Chicken</h3>
                <p class="subtitle">New England apple raisin bread stuffed chicken breast. Served with garlic mashed potatoes and asparagus.</p>
            </div>
        </div>
        <div class="grid wrap">
            <div class="col col-size-6">
                <h3 class="header">Mediterranean Vegan Ravioli</h3>
                <p class="subtitle">Pasta pillows stuffed with a blend of Mediterranean vegetables. Topped with char-boiled vegetables al olio and pomodoro sauce.</p>
            </div>
            <div class="col col-size-6">
                <h3 class="header">Chicken Fingers and French Fries</h3>
                <p class="subtitle">Kid's meal for children who are 10 years and under.</p>
            </div>
        </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Meals',
  components: {
    Hero,
    Footer
  }
}
</script>

<style scoped lang="scss">
    .container {
      margin: 80px auto;
      padding: 0 20px;
      text-align: center;
      max-width: 860px;

      .title {
            font-size: 2.5rem;
            margin: 0;
            padding-bottom: 24px;
            font-weight: 100;
      }
      .subtitle {
          font-size: 1.125rem;
          margin: 0;
          padding-bottom: 32px;
      }

      .grid {
        div {
            padding: 0 20px;

          .header {
            font-size: 1.125rem;
            text-transform: uppercase;
            letter-spacing: 0.15rem;
          }
        }
      }
    }

    @media only screen and (max-width: 768px) {
      .container {
        margin: 40px auto;

        .col:not(:last-child) {
          padding-bottom: 25px;
        }
      }
    }
</style>
